import React from 'react';
import { Typography } from '@mui/material';
import { RequestDocumentDialogSubtitleProps } from './RequestDocumentDialogSubtitle.props';

const RequestDocumentDialogSubtitle = ({ text }: RequestDocumentDialogSubtitleProps) => (
  <Typography variant="h4" gutterBottom>
    {text}
  </Typography>
);

export default React.memo(RequestDocumentDialogSubtitle);
